export const DEPTH_VALUES = {
	'0': 0,
	'1': 1,
	'2': 2,
	'3': 3,
	'4': 4,
	'5': 5,
	'6': 6,
	'7': 7,
	'8': 8,
	'9': 9,
	'10': 10,
	'11': 11,
	'12': 12,
	'>12': 13,
};

export const MARGIN_VALUES_POSITIVE = {
	'0': 0,
	'1': 1,
	'2': 2,
	'3': 3,
	'4': 4,
	'5': 5,
	'6': 6,
	'7': 7,
};

export const MARGIN_VALUES_NEGATIVE = {
	'0': 0,
	'-1': -1,
	'-2': -2,
	'-3': -3,
	'-4': -4,
	'-5': -5,
	'-6': -6,
	'-7': -7,
	'-8': -8,
	'-9': -9,
	'-10': -10,
	'-11': -11,
	'-12': -12,
	'<-12': -13,
};
